module.exports = __webpack_public_path__ + "static/media/1.ed7250a1.jpeg";